"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerMatrix = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var utils_1 = require("../utils");
var ColorPickerMatrix = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerMatrix, _super);
    function ColorPickerMatrix() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPickerMatrix.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "color-picker-component" },
            react_1.default.createElement(ColorPickerRow, { lightness: 0.7, initColor: this.props.initColor, onColorSelected: this.props.onColorSelected }),
            react_1.default.createElement(ColorPickerRow, { lightness: 0.5, initColor: this.props.initColor, onColorSelected: this.props.onColorSelected }),
            react_1.default.createElement(ColorPickerRow, { lightness: 0.3, initColor: this.props.initColor, onColorSelected: this.props.onColorSelected })));
    };
    return ColorPickerMatrix;
}(react_1.PureComponent));
exports.ColorPickerMatrix = ColorPickerMatrix;
var ColorPickerRow = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerRow, _super);
    function ColorPickerRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPickerRow.prototype.getCellClassNames = function (hslColor) {
        return classnames_1.default("color-picker-cell", "s-color-" + Math.floor(hslColor.h + (hslColor.s + hslColor.l) * 100));
    };
    ColorPickerRow.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "color-picker-row" }, utils_1.SATURATION_ARRAY.map(function (saturation) {
            var newColor = {
                h: _this.props.initColor.h,
                s: saturation,
                l: _this.props.lightness,
            };
            return (react_1.default.createElement("div", { role: "color", tabIndex: -1, key: _this.props.lightness + saturation, className: _this.getCellClassNames(newColor), style: utils_1.getColorStyle(newColor), onClick: function () { return _this.props.onColorSelected(newColor); } }));
        })));
    };
    return ColorPickerRow;
}(react_1.PureComponent));
//# sourceMappingURL=ColorPickerMatrix.js.map